module.exports = __webpack_public_path__ + "static/img/jeonbuk-innovation.7d9150a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/jeonbuk-innovation.jpg
// module id = E3OO
// module chunks = 0